import { GridColDef } from "@mui/x-data-grid";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateControleColumnDefinition
 */

type Props = {
  onActionDeletar: (idObraMateriaisControlados: number | null, openState: boolean) => void;
};

export const GenerateControleColumnDefinition = ({ onActionDeletar }: Props): GridColDef[] => {
  return [
    {
      field: "nroMaterial",
      filterable: false,
      headerName: "Nº",
      minWidth: 50,
      sortable: false,
      headerClassName: "descricao-header",
    },
    {
      field: "materiaisControlados",
      filterable: false,
      headerName: "Material",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: "descricao-header",
    },

    {
      field: "idObraMateriaisControlados",
      headerName: "Ações",
      sortable: false,
      filterable: false,
      width: 100,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton aria-label="Excluir material controlado" onClick={() => onActionDeletar(params.row.idObraMateriaisControlados, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
  ];
};
